module.exports = __webpack_public_path__ + "media/images/img_pr_female_1-5256badc1eac7013657b955d37af6896.png";